import { useMutation } from '@tanstack/react-query';
import { httpDeleteWorkspace } from 'services/backofficeIntegration/http/endpoints/workspace/httpDeleteWorkspace';

export const useDeleteWorkspaceMutation = () =>
  useMutation({
    mutationFn: async (workspaceId: string) => httpDeleteWorkspace.callEndpoint({ workspaceId }),
  });
